import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { useOnce } from '@root/src/web/lib/useOnce';
import { pickMessage, } from '@root/src/web/lib/messagePicker';
import { ReaderRevenueEpic, canShow as canShowReaderRevenueEpic, } from './ReaderRevenueEpic';
import { MaybeBrazeEpic, canShow as canShowBrazeEpic } from './BrazeEpic';
const buildReaderRevenueEpicConfig = ({ isSignedIn, countryCode, contentType, sectionName, shouldHideReaderRevenue, isMinuteArticle, isPaidContent, tags, contributionsServiceUrl, idApiUrl, }) => {
    return {
        candidate: {
            id: 'reader-revenue-banner',
            canShow: () => canShowReaderRevenueEpic({
                isSignedIn,
                countryCode,
                contentType,
                sectionName,
                shouldHideReaderRevenue,
                isMinuteArticle,
                isPaidContent,
                tags,
                contributionsServiceUrl,
                idApiUrl,
            }),
            show: (meta) => () => {
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                return _jsx(ReaderRevenueEpic, Object.assign({}, meta), void 0);
            },
        },
        timeoutMillis: null,
    };
};
const buildBrazeEpicConfig = (brazeMessages, contributionsServiceUrl, countryCode) => {
    return {
        candidate: {
            id: 'braze-epic',
            canShow: () => canShowBrazeEpic(brazeMessages),
            show: (meta) => () => (_jsx(MaybeBrazeEpic, { meta: meta, contributionsServiceUrl: contributionsServiceUrl, countryCode: countryCode }, void 0)),
        },
        timeoutMillis: 5000,
    };
};
export const SlotBodyEnd = ({ isSignedIn, countryCode, contentType, sectionName, shouldHideReaderRevenue, isMinuteArticle, isPaidContent, tags, contributionsServiceUrl, brazeMessages, idApiUrl, }) => {
    const [SelectedEpic, setSelectedEpic] = useState(null);
    useOnce(() => {
        const readerRevenueEpic = buildReaderRevenueEpicConfig({
            isSignedIn,
            countryCode,
            contentType,
            sectionName,
            shouldHideReaderRevenue,
            isMinuteArticle,
            isPaidContent,
            tags,
            contributionsServiceUrl,
            idApiUrl,
        });
        const brazeEpic = buildBrazeEpicConfig(brazeMessages, contributionsServiceUrl, countryCode);
        const epicConfig = {
            candidates: [readerRevenueEpic, brazeEpic],
            name: 'slotBodyEnd',
        };
        pickMessage(epicConfig)
            .then((PickedEpic) => setSelectedEpic(PickedEpic))
            .catch((e) => console.error(`SlotBodyEnd pickMessage - error: ${e}`));
    }, [isSignedIn, countryCode, brazeMessages]);
    if (SelectedEpic) {
        return _jsx(SelectedEpic, {}, void 0);
    }
    return null;
};
